"use strict";

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Styled = void 0;

var _styledComponents = require("styled-components");

var _theme = require("../../../theme");

var _utils = require("../../../utils");

var _button = require("./button.inject");

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translateY(-50%) translateX(-50%);\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n        &:active {\n          box-shadow: none;\n        }\n      "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        &:hover {\n          box-shadow: none;\n        }\n      "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    position: relative;\n\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    flex: 0 1 auto;\n\n    ", ";\n    border-radius: var(--border-radius);\n\n    ", ";\n\n    user-select: none;\n    transition: var(--transition);\n\n    ", "\n\n    &[disabled] {\n      cursor: not-allowed;\n      color: var(--c-neutral);\n\n      ", "\n\n      ", "\n    }\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Button = (0, _utils.sc)('button')(function (_ref) {
  var intent = _ref.intent,
      appearance = _ref.appearance,
      disabled = _ref.disabled,
      isLoading = _ref.isLoading;
  return (0, _styledComponents.css)(_templateObject(), _button.inject.getAppearance({
    isDisabled: disabled,
    isLoading: isLoading,
    intent: intent,
    appearance: appearance
  }), _theme.Mixin.Font.bodyRegular(), _button.inject.loadingStyles(isLoading), _theme.Mixin.Device.desktop((0, _styledComponents.css)(_templateObject2())), _theme.Mixin.Device.mobile((0, _styledComponents.css)(_templateObject3())));
})('Button');
var LoadingSpinner = (0, _utils.sc)('span')((0, _styledComponents.css)(_templateObject4()))('LoadingSpinner');
var Styled = {
  Button: Button,
  LoadingSpinner: LoadingSpinner
};
exports.Styled = Styled;